import React from 'react';
import { connect } from 'react-redux'
import {withTranslation} from "react-i18next";

import * as types from 'reducer/actionTypes';
import {isEmpty} from 'script/common';

class Account extends React.Component {
	componentWillMount(){
		this.props.fetchAccountInfo()
	}

	onSubmitLanguage=(e)=>{
		e.preventDefault();
		const value=document.getElementById('lang').value
		this.props.fetchSetLanguage(value)
	}

	onSubmitLoginId=(e)=>{
		e.preventDefault();
		const value={
			newUserId: document.getElementById('new_userId').value,
			userPwd: document.getElementById('login_password').value,
		}

		if(this.errorCheckUserid(value)){
			return
		}else{
			this.props.fetchChangeUserId(value)
		}
	}

	onSubmitPasswd = (e) => {
		e.preventDefault();
		const value={
			currentPwd: document.getElementById('current_password').value,
			newPwd: document.getElementById('new_password').value,
			confirmPwd: document.getElementById('confirm_password').value,
		}

		const event = document.getElementById('reset')
		
		if(this.errorCheckPasswd(value)){
			return
		}else{
			this.props.fetchChangePasswd(value,event)
		}
	}

	errorCheckUserid = (value) => {
		var errorLabel={}
		
		if(isEmpty(value.newUserId)){
			errorLabel={
				...errorLabel,
				newUserId:"aa.button.err.required"}
		}
		if(isEmpty(value.userPwd)){
			errorLabel={
				...errorLabel,
				userPwd:"aa.button.err.required"}
		}
		
		this.props.setErrorLabel(errorLabel)

		if(Object.keys(errorLabel).length > 0){
			return true
		}else{
			return false
		}
	}


	errorCheckPasswd = (value) => {
		var errorLabel={}
		
		if(isEmpty(value.currentPwd)){
			errorLabel={
				...errorLabel,
				currentPwd:"aa.button.err.required"}
		}
		if(isEmpty(value.newPwd)){
			errorLabel={
				...errorLabel,
				newPwd:"aa.button.err.required"}
		}
		if(isEmpty(value.confirmPwd)){
			errorLabel={
				...errorLabel,
				confirmPwd:"aa.button.err.required"}
		}
		
		this.props.setErrorLabel(errorLabel)

		if(Object.keys(errorLabel).length > 0){
			return true
		}else{
			return false
		}
	}

	render(){
		const {t} = this.props;

		const language=[
			{value:"auto"},
			{value:"en_US"},
			{value:"ko_KR"}
		]

		const SelectLanguage = () => {
			return (
					<select className="item_dropdown_select active" id="lang" defaultValue={this.props.account.data.language}>
						{language.map((data) => {
							return <option value={data.value} key={data.value}>{t(data.value)}</option>
						})}
					</select>
					)
		}

		return(
		<>
			<h2>{t('user.account.top.title')}</h2>
			<div className="content_box">
				{/* <!-- 사용 언어 --> */}
				<form className="form" onSubmit={this.onSubmitLanguage}>
					<div className="section">
						<div className="item_label">{t('m.account.label.language')}</div>
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.passwd)}</div>
						{isEmpty(this.props.account.data.language) ? null : <SelectLanguage/>}
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.lang)}</div>
						<div className="btn_wrap">
							<button className="btn_text_b">{t('user.account.save')}</button>
						</div>
					</div>
				</form>
				{/* <!-- //사용 언어 --> */}
				<hr className="section_hr"/>
				{/* <!-- 현재 아이디 --> */}
				<form className="form" onSubmit={this.onSubmitLoginId}>
					<div className="section">
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.loginId)}</div>
						<div className="item_label">{t('user.account.current.id')}</div>
						<input type="text" className="item_input" id="current_userId" defaultValue={this.props.account.data.loginId} readOnly/>
						<div className="item_label">{t('user.account.new.id')}</div>
						<input type="text" className="item_input" id="new_userId" autoComplete="off" placeholder={t('user.account.new.id.placeholder')}/>
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.newUserId)}</div>
						<div className="item_label">{t('user.account.current.password')}</div>
						<input type="password" className="item_input" id="login_password" autoComplete="off" placeholder={t('user.account.current.password.placeholder')}/>
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.userPwd)}</div>
						<div className="btn_wrap">
							<button className="btn_text_b">{t('user.account.save')}</button>
						</div>
					</div>
				</form>
				{/* <!-- //현재 아이디 --> */}
				<hr className="section_hr"/>
				{/* <!-- 현재 비밀번호 -->f */}
				<form className="form" onSubmit={this.onSubmitPasswd}>
					<div className="section">
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.password)}</div>
						<div className="item_label">{t('user.account.current.password')}</div>
						<input type="password" className="item_input" id="current_password" autoComplete="off" placeholder={t('user.account.current.password.placeholder')}/>
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.currentPwd)}</div>
						<div className="item_label">{t('user.account.new.password')}</div>
						<input type="password" className="item_input" id="new_password" autoComplete="off" placeholder={t('user.account.new.password.placeholder')}/>
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.newPwd)}</div>
						<div className="item_label">{t('user.account.confirm.new.password')}</div>
						<input type="password" className="item_input" id="confirm_password" autoComplete="off" placeholder={t('user.account.confirm.new.password.placeholder')}/>
						<div className="error" style={{display:'block'}}>{t(this.props.account.errorLabel.confirmPwd)}</div>
						<div className="btn_wrap">
							<button className="btn_text_b">{t('user.account.save')}</button>
						</div>
						<input type="reset" id="reset" style={{display:"None"}}/>
					</div>
				</form>
				{/* <!-- //현재 비밀번호 --> */}
			</div>
		</>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		account: reducers.account
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		setErrorLabel: (value) => {dispatch({type: types.SET_ACCOUNT_ERRORLABEL,errorLabel:value})},
		fetchAccountInfo: () => {dispatch({type: types.FETCH_GET_ACCOUNT_INFO_REQUEST})},
		fetchSetLanguage: (value) => {dispatch({type: types.FETCH_GET_ACCOUNT_LANGUAGE_REQUEST,value:value})},
		fetchChangeUserId: (value) => {dispatch({type: types.FETCH_SET_ACCOUNT_CHANGE_USERID_REQUEST,value:value})},
		fetchChangePasswd: (value,event) => {dispatch({type: types.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_REQUEST,value:value, event:event})},		
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Account))